import React from 'react';

import { Grid } from 'e100-react-components';
import { Typography } from 'shared/components';
import { Icon } from 'components';
import { Box } from 'shared/components';

import { useIntl } from 'react-intl';
import { useStyles } from './styles';

export const ErrorMessage = () => {
  const { formatMessage } = useIntl();
  const classes = useStyles();

  return (
    <Grid
      container
      wrap="nowrap"
      direction="column"
      justify='center'
      alignItems='center'
      classes={{
        root: classes.container
      }}
    >
      <Grid item>
        <Icon
          kind="infoOutlined"
          color="secondary"
          classes={{
            root: classes.icon
          }}
        />
      </Grid>
      <Grid item>
        <Box
          padding={{
            left: 2,
            right: 2
          }}
        >
          <Typography variant='subtitle1' textAlign='center'>
            {formatMessage({ id: 'error.title' })}
          </Typography>
          <Typography variant='body2' textAlign='center'>
            {formatMessage({ id: 'error.message' })}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};
